/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DashboardListEntry } from './DashboardListEntry';
import {
    DashboardListEntryFromJSON,
    DashboardListEntryFromJSONTyped,
    DashboardListEntryToJSON,
    DashboardListEntryToJSONTyped,
} from './DashboardListEntry';

/**
 * 
 * @export
 * @interface FindAllDashboards200Response
 */
export interface FindAllDashboards200Response {
    /**
     * 
     */
    data?: Array<DashboardListEntry>;
}

/**
 * Check if a given object implements the FindAllDashboards200Response interface.
 */
export function instanceOfFindAllDashboards200Response(value: object): value is FindAllDashboards200Response {
    return true;
}

export function FindAllDashboards200ResponseFromJSON(json: any): FindAllDashboards200Response {
    return FindAllDashboards200ResponseFromJSONTyped(json, false);
}

export function FindAllDashboards200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllDashboards200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(DashboardListEntryFromJSON)),
    };
}

export function FindAllDashboards200ResponseToJSON(json: any): FindAllDashboards200Response {
    return FindAllDashboards200ResponseToJSONTyped(json, false);
}

export function FindAllDashboards200ResponseToJSONTyped(value?: FindAllDashboards200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(DashboardListEntryToJSON)),
    };
}

